module.exports = __webpack_public_path__ + "img/Sensor Folhar.ca966c66.svg";